import * as R from 'ramda'
import { post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'
import { MODE_MONTHLY, MODE_WEEKLY } from './const'


export const changeModeMonthly = () => ({
    type: type.CHANGE_MODE,
    payload: {
        mode: MODE_MONTHLY,
    },
})

export const changeModeWeekly = () => ({
    type: type.CHANGE_MODE,
    payload: {
        mode: MODE_WEEKLY,
    },
})

export const changeFunnelStartTime = (name, value) => (dispatch, getState) => {
    dispatch({
        type: type.CHANGE_FUNNEL_START_DEFINITION,
        payload: {
            name,
            value,
        },
    })
    dispatch(findCohort())
}

export const findCohortRequest = () => ({
    type: type.FIND_COHORT_REQUEST,
})

export const findCohortSuccess = (firstCohort, cohortList) => ({
    type: type.FIND_COHORT_SUCCESS,
    payload: {
        firstCohort,
        cohortList,
    },
})

export const findCohortError = (error) => ({
    type: type.FIND_COHORT_ERROR,
    payload: {
        error,
    },
})


export const findCohort = () => (dispatch, getState) => {
    const state = getState()
    const funnelStartTime = selector.selectFunnelStartTime(state)
    const firstFunnelStep = selector.selectFirstFunnelStep(state)
    const mode = selector.selectMode(state)

    const path = mode === MODE_MONTHLY ? '/api/process/analytics/state-cohort' : '/api/process/analytics/state-cohort-weekly'

    dispatch(findCohortRequest())
    dispatch(findCurrentState())

    post(path, {
        ...funnelStartTime,
        ...firstFunnelStep,
    })
        .then(cohortList => {
            let firstCohort = null
            R.forEach(cohort => {
                if (cohort.processName === firstFunnelStep.processName && cohort.stateName === firstFunnelStep.stateName) {
                    firstCohort = cohort
                }
            }, cohortList)
            dispatch(findCohortSuccess(firstCohort, cohortList))
        })
        .catch(error => {
            dispatch(findCohortError(error))
        })
}


export const changeFunnelStep = (funnelStepIndex, name, value) => (dispatch, getState) => {
    dispatch({
        type: type.CHANGE_FUNNEL_STEP,
        payload: {
            name,
            value,
            funnelStepIndex,
        },
    })

    if (funnelStepIndex === 0) {
        dispatch(findCohort())
    }
}


export const findCurrentStateRequest = () => ({
    type: type.FIND_CURRENT_STATE_REQUEST,
})

export const findCurrentStateSuccess = (currentState) => ({
    type: type.FIND_CURRENT_STATE_SUCCESS,
    payload: {
        currentState,
    },
})

export const findCurrentStateError = (error) => ({
    type: type.FIND_CURRENT_STATE_ERROR,
    payload: {
        error,
    },
})

export const findCurrentState = () => (dispatch, getState) => {
    const state = getState()
    const funnelStartTime = selector.selectFunnelStartTime(state)
    const firstFunnelStep = selector.selectFirstFunnelStep(state)
    const mode = selector.selectMode(state)

    const path = mode === MODE_MONTHLY ? '/api/process/analytics/state-cohort-current-state' : '/api/process/analytics/state-cohort-weekly-current-state'

    dispatch(findCurrentStateRequest())
    post(path, {
        ...funnelStartTime,
        ...firstFunnelStep,
    })
        .then(currentState => {
            dispatch(findCurrentStateSuccess(currentState))
        })
        .catch(error => {
            dispatch(findCohortError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/funnel-builder/action.js